import {Validators} from '@angular/forms';

import {ClientUserTypesEnum} from '@spa/api';
import {InArrayValidator, NameValidator, WhitespaceValidator} from '@spa/validators';

import {PhoneAutocompleteValueInterface} from '../../../app/shared/widgets';
import {ColorCodesEnum, ComponentTypesEnum} from '../../../app/shared/enums';
import {DialogButtonTypesEnum, DialogConfigInterface} from '../../../app/shared/components/dialog';
import {BaseControl, PhoneAutocompleteControl, RadioGroupControl} from '../../../app/shared/classes';

export const ClientUserFirstNameSelector = 'firstName';
export const ClientUserMiddleNameSelector = 'middleName';
export const ClientUserLastNameSelector = 'lastName';
export const ClientUserEmailSelector = 'email';
export const ClientUserPhoneSelector = 'phoneNumber';
export const ClientUserTypeSelector = 'type';

export const AddUserToClientControls = (): BaseControl<string | number | PhoneAutocompleteValueInterface>[] => {
    return [
        new BaseControl({
            name: ClientUserFirstNameSelector,
            value: '',
            placeholder: 'First name',
            validators: [WhitespaceValidator(), NameValidator()],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: ClientUserMiddleNameSelector,
            value: '',
            placeholder: 'Middle name(optional)',
            validators: [NameValidator()],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: ClientUserLastNameSelector,
            value: '',
            placeholder: 'Last name',
            validators: [WhitespaceValidator(), NameValidator()],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: ClientUserEmailSelector,
            value: '',
            placeholder: 'Email',
            validators: [Validators.required, Validators.email],
            componentType: ComponentTypesEnum.Text
        }),
        new PhoneAutocompleteControl({
            name: ClientUserPhoneSelector,
            value: null,
            placeholder: 'Phone',
            validators: [],
            componentType: ComponentTypesEnum.PhoneAutocomplete,
            countries: [],
        }),
        new RadioGroupControl({
            name: ClientUserTypeSelector,
            value: null,
            placeholder: 'Type',
            validators: [
                Validators.required,
                InArrayValidator([ClientUserTypesEnum.LegalRepresentative, ClientUserTypesEnum.AuthorizedPerson])
            ],
            componentType: ComponentTypesEnum.RadioGroup,
            options: [
                {
                    label: 'Legal Representative',
                    value: ClientUserTypesEnum.LegalRepresentative,
                    color: ColorCodesEnum.Primary
                },
                {
                    label: 'Authorized Person',
                    value: ClientUserTypesEnum.AuthorizedPerson,
                    color: ColorCodesEnum.Primary
                }
            ]
        })
    ];
};

export const AddUserToClientDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: 'User adding failed.',
            succeedMessage: 'User is successfully added.'
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};
